module.exports = __webpack_public_path__ + "static/media/GM.eb0c7cba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GM.svg
// module id = 2159
// module chunks = 7